import RestApiService from "./RestApiService"

const controller = "/proveedor2"

const ProveedorService = {
    obtenerDatosxRuc: (request) => {
        return RestApiService.send(`${controller}/obtenerDatosxRuc`, request)
    },
    crearCuenta: (request) => {
        return RestApiService.send(`${controller}/crearCuenta`, request)
    },
}

export default ProveedorService